module.exports = __webpack_public_path__ + "img/features_sales.0ec21b71.png";